import './App.css';
import React from 'react';
import socketIOClient from "socket.io-client";
import Box from './Box';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      boxes: []
    };
  }

  componentDidMount() {
    this.listenToSocket();
  }

  listenToSocket() {
    if(this.socket) return; // prevent multiple connections
    // this.socket = socketIOClient();

    this.socket = socketIOClient('/', {
      query: {
        visualizer: 'true'
      }
    });

    // some debugging statements concerning socket.io
    this.socket.on('reconnecting', seconds => {
      console.log('reconnecting in ' + seconds + ' seconds');
    });

    this.socket.on('reconnect', () => {
      console.log('reconnected');
    });

    this.socket.on('reconnect_failed', () => {
      console.log('failed to reconnect');
    });

    this.socket.on('connect', () => {
      console.log('socket connected');
    });

    // state of the boxes is kept on the server.
    // gets this info from the server when the visualizer connects
    this.socket.on('boxes', boxes => {
      console.log(`> Boxes:`, boxes);
      // Add empty reads array to each box
      const boxesWithReads = boxes.map(box => ({
        ...box,
        reads: []
      }));
      this.setState({ boxes: boxesWithReads });
    });

    // boxUpdate is sent when a box is connected, disconnected, or when the voltage or temperature changes
    // this can a box that is not in the boxes array yet, so we need to add it
    this.socket.on('boxUpdate', updatedBox => {
      console.log(`> Box updated:`, updatedBox);
      const boxIndex = this.state.boxes.findIndex(box => box.id === updatedBox.id);

      if (boxIndex === -1) {
        // Box doesn't exist, add it with empty reads array
        this.setState(prevState => ({
          boxes: [...prevState.boxes, {
            ...updatedBox,
            reads: []
          }]
        }));
      } else {
        // Box exists, update everything except reads
        this.setState(prevState => ({
          boxes: prevState.boxes.map((box, index) =>
            index === boxIndex
              ? { ...box, ...updatedBox, reads: box.reads }
              : box
          )
        }));
      }
    });

    this.socket.on('read', read => {
      console.log(`> Read:`, read);
      var box = this.state.boxes.find(box => box.id == read.box_nr); // the original message has box_nr to indicate the box id
      if(!box) return; // should not happen, unless we get a read before we have the box state
      box.reads.push(read);
      this.setState({boxes: this.state.boxes});
    });
  }

  render() {
    var renderedBoxes = this.state.boxes
      .sort((a, b) => a.id - b.id)
      .map(box => {
        return (
          <Box key={box.id} box={box} />
        );
      });

    return(
      <div className="App">
        <div className="boxes">
          {renderedBoxes}
        </div>
      </div>
    );
  }
}

export default App
